import React from 'react';
import './sectionHeader.module.scss';

type Props = {
  title: string;
  subTitle: string;
};

export const SectionHeader = ({ title, subTitle }: Props) => (
  <div styleName="section-header">
    <div styleName="section-title">{title}</div>
    <div styleName="section-sub-title">{subTitle}</div>
  </div>
);
